import {
  Box,
  Flex,
  HStack,
  Link,
  IconButton,
  useDisclosure,
  useColorModeValue,
  Stack,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { transformString } from '../util/util';
import { useTranslation } from 'react-i18next';

const NavLink = ({ route, children }) => {
  if(!route){
    route = children;
  }
  return (
    <RouterLink
      to={
        route === 'Estado de Cuenta'
          ? '/estado-cuenta'
          : route === 'Liberar Noches'
          ? '/liberar-noches'
          : route === 'Membresías'
          ? '/membresias'
          : route === 'Reservar'
          ? '/reservar-ahora'
          : route === 'Day Pass'
          ? '/day-pass'
          : `/${route.toLowerCase()}`
      }
    >
      <Link
        color="white"
        px={2}
        py={1}
        rounded={'md'}
        _hover={{
          textDecoration: 'none',
          bg: useColorModeValue('gray.700', 'gray.200'),
        }}
      >
        {children}
      </Link>
    </RouterLink>
  );
};

export const ChakraNav = ({ type, handleLogout, moroso = false }) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const navigate = useNavigate();

  const Links =
    type === 'admin'
      ? [
          'Socios',
          'Postventas',
          'Finanzas'
        ]
      : type === 'titular'
      ? !moroso
        ? [
            'Resumen',
            'Reservar',
            'Reservaciones',
            'Estado de Cuenta',
            'Day Pass',
          ]
        : ['Resumen', 'Estado de Cuenta']
      : ['Socios', 'Finanzas'];

  return (
    <>
      <Box
        bg={useColorModeValue('gray.900', 'gray.100')}
        px={4}
        py={4}
      >
        <Flex
          h={16}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={'Open Menu'}
            display={{ lg: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack
            spacing={8}
            alignItems={'center'}
          >
            <RouterLink
              to="/"
              className="sub-nav"
            >
              <img
                alt="nav"
                src="/assets/Logo-sin-fondo-blanco.png"
              />
            </RouterLink>
            <HStack
              as={'nav'}
              spacing={4}
              display={{ base: 'none', lg: 'flex' }}
            >
              {Links.map((link) => (
                <NavLink key={link} route={link === 'Day Pass' ? 'day-pass' : link}>
                  {t(transformString(link))}
                </NavLink>
              ))}
              {
                type === 'admin' && (
                  <Menu>
                    <MenuButton
                      px={4}
                      py={2}
                      transition='all 0.2s'
                      borderRadius={".375rem"}
                      color={'white'}
                      _hover={{ bg: '#2d3748', color: '#fecf9d' }}
                      _expanded={{ bg: '#2d3748', color: '#fecf9d' }}
                    >
                      {t('CONFIGURATION')}
                    </MenuButton>
                    <MenuList backgroundColor={"#171923"} borderRadius={".375rem"} borderColor={"#171923"}>
                      {/* <MenuItem 
                        onClick={() => navigate('/finanzas')}
                        backgroundColor={"#171923"} 
                        color={"#ffffff"} 
                        _hover={{ bg: '#2d3748', color: '#fecf9d' }}>
                        {t('FINANZAS')}
                      </MenuItem> */}
                      <MenuItem
                        onClick={() => navigate('/temporadas')}
                        backgroundColor={"#171923"}
                        color={"#ffffff"}
                        _hover={{ bg: '#2d3748', color: '#fecf9d' }}>
                        {t('SEASONS')}
                      </MenuItem>
                      <MenuItem 
                        onClick={() => navigate('/membresias')}
                        backgroundColor={"#171923"} 
                        color={"#ffffff"} 
                        _hover={{ bg: '#2d3748', color: '#fecf9d' }}>
                        {t('MEMBERSHIPS')}
                      </MenuItem>
                      <MenuItem 
                        onClick={() => navigate('/day-pass')}
                        backgroundColor={"#171923"} 
                        color={"#ffffff"} 
                        _hover={{ bg: '#2d3748', color: '#fecf9d' }}>
                        {t('DAY_PASS')}
                      </MenuItem>
                    </MenuList>
                  </Menu>
                )
              }
            </HStack>
            <HStack>
              <Link onClick={handleLogout}>
                <Button colorScheme="red">{t('LOGOUT')}</Button>
              </Link>
            </HStack>
          </HStack>
        </Flex>

        {isOpen ? (
          <Box
            pb={4}
            display={{ lg: 'none' }}
          >
            <Stack
              as={'nav'}
              spacing={4}
            >
              {Links.map((link) => (
                <NavLink key={link} route={link}>
                  {link}
                </NavLink>
              ))}
              <Link onClick={handleLogout}>
                <Button colorScheme="red">
                  {t('LOGOUT')}
                </Button>
              </Link>
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
};
